// src/components/BoardPack/pages/consolidate_boardpack/Bussiness_Performance_By_Country.jsx
import React, { useEffect, useRef, useState } from "react";
import { useQueue } from "@/context/QueueContext";
import { useNavigate } from "react-router-dom";
import ErrorState from "@/components/common/ErrorStateComponent";
import LoadingComponent from "@/components/common/LoadingComponent";
import { apiCall } from "@/api/apiCall";
import { processParams } from "../../utils/paramsHelper";
import { dynamicKey } from "../../utils/dynamicKey";
import Bussiness_Performance_By_Country_Component from "../../components/consolidate_boardpack_components/Bussiness_Performance_By_Country_Component";

const Bussiness_Performance_By_Country = ({ year = "", month = "", contract = "", page = null, isRefresh = false }) => {
  const { enqueue } = useQueue();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [meta, setMeta] = useState(null);
  const hasFetchedRef = useRef(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiParams = processParams(page?.params || {}, { year, month, contract });

      const response = await enqueue(() =>
        apiCall("GET", "/boardpack/consolidate", apiParams, navigate, false, false, isRefresh)
      );

      if (!response?.success) {
        throw new Error(response?.message || "API returned unsuccessful response");
      }

      setTableData(response.data);
      setMeta(response.meta);
    } catch (err) {
      console.error("Business Performance By Country fetch error:", err);
      setError(err.message || "Failed to load data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!year || !month || !contract) return;
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchData();
  }, [year, month, contract]);

  if (loading) {
    return <LoadingComponent />;
  }

  if (error) {
    return <ErrorState error={error} onRetry={fetchData} />;
  }

  const reportTitle = page?.title
    ? dynamicKey({ text: page.title, year, month, contract })
    : `Business Performance by Country - P&L's as at ${meta?.month} - ${meta?.year}  Actual -v- Budget and PY - Reporting Currency`;

  return (
    <Bussiness_Performance_By_Country_Component
      reportTitle={reportTitle}
      blocks={tableData?.blocks || []}
      headerYears={tableData?.headerYears}
      headerMonths={tableData?.headerMonths}
      headerMeasures={tableData?.headerMeasures}
    />
  );
};

export default Bussiness_Performance_By_Country;
